import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const BUSINESSANALYTICS_INITIAL: BUSINESSANALYTICS = {
  businessAnalytics: [],
  activeTab: "followers",
  isLoading: false,
};

const businessAnalyticsSlice = createSlice({
  name: "businessAnalytics",
  initialState: {
    ...BUSINESSANALYTICS_INITIAL,
  },
  reducers: {
    BUSINESSANALYTICS_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { BUSINESSANALYTICS_UPDATE } = businessAnalyticsSlice.actions;

export { businessAnalyticsSlice, BUSINESSANALYTICS_INITIAL, BUSINESSANALYTICS_UPDATE };
